// extracted by mini-css-extract-plugin
export default {"paginationButton":"Pagination_paginationButton__b5Tc6"};